import React from 'react';
import Section from 'evcharging/containers/layout/Section';
import Container from 'evcharging/components/Container';
import Responsible from 'evcharging/components/Responsible';
import Baget from 'evcharging/components/Baget';
import Spacer from 'evcharging/components/Spacer';
import Box from 'evcharging/components/Box';
import Paragraph from 'evcharging/components/Paragraph';
import BigTitle from 'evcharging/components/BigTitle';
import useI18n from 'evcharging/hooks/useI18n';

const WhyOpenAdr = () => {
  const { t } = useI18n();

  return (
    <Section>
      <Container>
        <Responsible fractions={[44, 45]} maxWidth={1000} margin={'0 auto'}>
          <Box>
            <Baget>{t('open.why.label')}</Baget>
            <Spacer value={16} />
            <BigTitle variant={'h2'}>{t('open.why.title')}</BigTitle>
          </Box>
          <Paragraph color={'middle'}>{t('open.why.body')}</Paragraph>
        </Responsible>
      </Container>
    </Section>
  );
};

export default WhyOpenAdr;
